import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import { KeyRound } from 'lucide-react';
import { statisticActions } from 'Containers/Statistic/store';
import styles from './StatsPasswordGate.module.scss';

const StatsPasswordGate = ({ onUnlocked, compact = false }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    setPassword('');
    setError('');
    setSubmitting(false);
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const value = password.trim();
    if (!value || submitting) return;

    setSubmitting(true);
    setError('');
    dispatch(
      statisticActions.UNLOCK_STATISTICS.REQUEST({ password: value }, (err) => {
        setSubmitting(false);
        if (err) {
          if (err.code === 'UNLOCK_UNAVAILABLE') {
            setError(t('statistics.passwordGate.unavailable'));
          } else {
            setError(t('statistics.passwordGate.error'));
          }
          return;
        }
        setPassword('');
        setError('');
        onUnlocked?.();
      }),
    );
  };

  return (
    <div
      className={`${styles.shell}${compact ? ` ${styles.shell_compact}` : ''}`}
      role="dialog"
      aria-modal="true"
      aria-labelledby="stats-unlock-title"
    >
      <form
        className={styles.gate}
        onSubmit={handleSubmit}
        // Evita binding HubSpot / autofill aggressivi sul form
        data-hs-ignore="true"
        autoComplete="off"
      >
        <div className={styles.head}>
          <span className={styles.icon} aria-hidden="true">
            <KeyRound size={22} strokeWidth={2.2} />
          </span>
          <h2 id="stats-unlock-title" className={styles.title}>
            {t('statistics.passwordGate.title')}
          </h2>
        </div>
        <p className={styles.subtitle}>{t('statistics.passwordGate.subtitle')}</p>
        <label className={styles.label} htmlFor="stats-unlock-password">
          {t('statistics.passwordGate.placeholder')}
        </label>
        <input
          id="stats-unlock-password"
          className={styles.input}
          type="password"
          name="stats-unlock-password"
          autoComplete="off"
          value={password}
          onChange={(e) => {
            setPassword(e.target.value);
            if (error) setError('');
          }}
          placeholder={t('statistics.passwordGate.placeholder')}
          disabled={submitting}
        />
        {error ? (
          <p className={styles.error} role="alert">
            {error}
          </p>
        ) : null}
        <Button
          type="submit"
          className={styles.cta}
          disabled={submitting || !password.trim()}
        >
          {t('statistics.passwordGate.confirm')}
        </Button>
      </form>
    </div>
  );
};

export default StatsPasswordGate;
